import { node_observable_component } from 'common/util/ComponentDecorator';

@node_observable_component
export default class formSetPassword {
	static classname = 'form-set-password';

	constructor($form) {
		this.$form = $form;
		this.decorate();
		this.init();
		this.bindEvents();
	}

	init = () => {
		this.is_disabled_button = true;
	};

	decorate = () => {
		this.$form.find('.wa-buttons-wrapper').append(
			'<button type="submit" class="form__btn btn btn--green">Сохранить и войти</button>');
		this.$form.find('.wa-field').each(function() {
			const $this = $(this);
			$this.find('.custom-label').html($this.find('.wa-name').html());
		});

	};

	bindEvents = () => {
		this.$input.on('input', () => {
			let isDisabledButton = false;
			this.$input.each(function() {
				if (!$(this).val()) {
					isDisabledButton = true;
					return false;
				}
			});
			this.is_disabled_button = isDisabledButton;
		});
	};

	set is_disabled_button(state) {
		this.$button.toggleClass('btn--disabled', state);
	}

	get $button() {
		return this.$form.find('.form__btn');
	}

	get $input() {
		return this.$form.find('input[name*="password"]');
	}

}
